export const tipsBaopalsScoreUrl = () => "https://blog.baopals.com/shopping-tips/the-baopals-score/"
